import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

class Navigation {
  constructor() {
    this.hamburger = document.querySelector('.c-burger')
    this.body = document.body
    this.state = false
    this.init()
  }

  init() {
    this.hamburger.addEventListener('click', () => {
      this.toggleMenu()
    })

    if (document.querySelector('.s-frontpage')) {
      // get data-theme value from html
      const theme = document.documentElement.getAttribute('data-theme')
      const hero = theme === 'tapenade' ? '.c-frontpage-hero' : '.c-frise-hero'

      const trigger = ScrollTrigger.create({
        trigger: hero,
        start: 'top top+=10%',
        end: 'bottom',
        id: 'hero',
        // markers: true,
        onEnterBack: () => {
          document.body.classList.remove('is-past-hero')
          document.body.classList.remove('is-past-top')
        },
        onLeave: () => {
          document.body.classList.add('is-past-hero')
          document.body.classList.add('is-past-top')
        },
      })
    } else {
      window.addEventListener('scroll', this.onScroll.bind(this))
    }
  }

  onScroll() {
    let ticking = false
    if (!ticking) {
      window.requestAnimationFrame(() => {
        if (window.scrollY > 0) {
          this.body.classList.add('is-past-top')
        } else {
          this.body.classList.remove('is-past-top')
        }
        ticking = false
      })
    }
    ticking = true
  }

  toggleMenu() {
    if (this.state) {
      this.closeMenu()
    } else {
      this.openMenu()
    }
  }

  closeMenu() {
    document.body.classList.remove('has-menu')
    this.hamburger.setAttribute('aria-expanded', false)
    this.state = false
  }

  openMenu() {
    document.body.classList.add('has-menu')
    this.hamburger.setAttribute('aria-expanded', true)
    this.state = true
  }
}

export default Navigation
